module.exports = __webpack_public_path__ + "img/p4-1.b684b077.png";